import { create } from "zustand"
import type { Activities } from "../entities/activities"

interface WeeklyObjectivesState {
  activities: Activities[]
  setActivities: (obj: Activities[]) => void
}

export const useActivitiesStore = create<WeeklyObjectivesState>((set) => ({
  activities: [],
  setActivities: (activities: Activities[]) =>
    set(() => ({
      activities: activities.map((activity) => ({
        ...activity,
        activities: activity.activities.sort((a, b) => {
          if (a.status === "approved" && b.status !== "approved") {
            return 1
          }
          if (a.status !== "approved" && b.status === "approved") {
            return -1
          }
          return 0
        }),
      })),
    })),
}))

export default useActivitiesStore.getState()
